import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
	selector: 'app-closer-sync-institution-save-modal',
	templateUrl: './closer-sync-institution-save-modal.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class CloserSyncInstitutionSaveModalComponent {
	constructor(
		private dialogRef: MatDialogRef<CloserSyncInstitutionSaveModalComponent>,
	) {}

	close(): void {
		this.dialogRef.close(false);
	}

	confirm(): void {
		this.dialogRef.close(true);
	}
}
